import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useBoundarySections');

    return {
        FIELD_BOUNDARIES: t('fieldBoundaries'),
        OTHER_FIELD_BOUNDARIES: t('otherFieldBoundaries'),
        UNASSIGNED_BOUNDARIES: t('unassignedBoundaries')
    };
};

export default useTranslation;
